module.exports = __webpack_public_path__ + "0abcf81f670fd0163fb2b1e46f8167bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/radio-icon/swatch.svg
// module id = 1554
// module chunks = 0 1